import type {
  GetProductDetailResponse,
  ProductDetailsDTO,
} from './ownable.dtos';
import { GetProductDetail } from './ownable.dtos';
import ServiceStackGateway from './service-stack';

import type { IProductDetail } from '~types/models-types';

// eslint-disable-next-line @typescript-eslint/no-extraneous-class
class ProductsAPI {
  public static async getProductDetailAsync(
    productId: number
  ): Promise<IProductDetail> {
    const request = new GetProductDetail();
    request.productId = productId;

    const { productDetail } =
      await ServiceStackGateway.get<GetProductDetailResponse>(request);

    return ProductsAPI.productDetailToIProductDetail(productDetail);
  }

  private static productDetailToIProductDetail(
    dto: ProductDetailsDTO
  ): IProductDetail {
    return {
      id: dto.id,
      brand: dto.brand,
      name: dto.name,
      featuredIn: dto.featuredIn,
      description: dto.description,
      rrp: dto.rrp,
      priceLabel: dto.priceLabel,
      optionsLabel: dto.optionsLabel,
      price: dto.price,
      unit: dto.unit,
      mediaUrls: dto.imageUrls,
      tooltip: dto.name,
      options: dto.options.map((o) => ({
        id: o.id,
        default: o.baseProduct,
        imageUrl: o.imageUrl ?? null,
        optionName: o.name,
        price: o.price ?? null,
        rrp: o.rrp,
      })),
      actions: dto.actions,
    };
  }
}

export default ProductsAPI;
